import { Dispatch, SetStateAction } from 'react';

import { STORAGE_KEYS } from 'utils/constants/constants';
import { EListsTypes, ICustomizeTableColumn } from 'types/listsTypes';

export const COLUMN = 'column';

export interface ICustomizeTableProps {
  listType: EListsTypes,
  onModalClose: () => void,
}

export interface IColumnsProps {
  columns: ICustomizeTableColumn[];
  setColumns: Dispatch<SetStateAction<ICustomizeTableColumn[]>>;
}

export interface IColumnProps {
  id: any
  title: string,
  index: number,
  isChecked: boolean,
  isFixed: boolean | undefined;
  onColumn: Dispatch<SetStateAction<ICustomizeTableColumn[]>>;
}

export interface DragItem {
  index: number,
  id: string,
  type: string,
}

export const tableLocalStorageKeyByType = {
  [EListsTypes.ProductsType]: STORAGE_KEYS.productsTable,
  [EListsTypes.OrdersType]: STORAGE_KEYS.ordersTable,
};
